{
  "AUDIT_LOGS": {
    "HEADER": "Logs de auditoria",
    "HEADER_BTN_TXT": "Adicionar logs de auditoria",
    "LOADING": "A obter logs de auditoria",
    "DESCRIPTION": "Os logs de auditoria mantêm um registo das atividades na sua conta, permitindo-lhe acompanhar e auditar a sua conta, equipa ou serviços.",
    "LEARN_MORE": "Saber mais sobre os logs de auditoria",
    "SEARCH_404": "Não existem itens correspondentes a esta consulta",
    "SIDEBAR_TXT": "<p><b>Logs de auditoria</b> </p><p> Logs de auditoria são registos de eventos e ações de um sistema. </p>",
    "LIST": {
      "404": "Não há logs de auditoria referentes a esta conta.",
      "TITLE": "Gerir logs de auditoria",
      "DESC": "Logs de auditoria são registos de eventos e ações do sistema.",
      "TABLE_HEADER": {
        "ACTIVITY": "User",
        "TIME": "Horário",
        "IP_ADDRESS": "Endereço IP"
      }
    },
    "API": {
      "SUCCESS_MESSAGE": "Logs de auditoria recuperados com sucesso",
      "ERROR_MESSAGE": "Não foi possível conectar ao servidor Woot, por favor, tente novamente mais tarde"
    },
    "DEFAULT_USER": "Sistema",
    "AUTOMATION_RULE": {
      "ADD": "{agentName} created a new automation rule (#{id})",
      "EDIT": "{agentName} updated an automation rule (#{id})",
      "DELETE": "{agentName} deleted an automation rule (#{id})"
    },
    "ACCOUNT_USER": {
      "ADD": "{agentName} convidou {invitee} para a conta como {role}",
      "EDIT": {
        "SELF": "{agentName} alterou o seu {attributes} para {values}",
        "OTHER": "{agentName} alterou o parâmetro {attributes} do utilizador {user} para {values}",
        "DELETED": "{agentName} alterou o parâmetro {attributes} de um utilizador excluído para {values}"
      }
    },
    "INBOX": {
      "ADD": "{agentName} created a new inbox (#{id})",
      "EDIT": "{agentName} updated an inbox (#{id})",
      "DELETE": "{agentName} deleted an inbox (#{id})"
    },
    "WEBHOOK": {
      "ADD": "{agentName} created a new webhook (#{id})",
      "EDIT": "{agentName} updated a webhook (#{id})",
      "DELETE": "{agentName} deleted a webhook (#{id})"
    },
    "USER_ACTION": {
      "SIGN_IN": "{agentName} iniciou sessão",
      "SIGN_OUT": "{agentName} terminou sessão"
    },
    "TEAM": {
      "ADD": "{agentName} created a new team (#{id})",
      "EDIT": "{agentName} updated a team (#{id})",
      "DELETE": "{agentName} deleted a team (#{id})"
    },
    "MACRO": {
      "ADD": "{agentName} created a new macro (#{id})",
      "EDIT": "{agentName} updated a macro (#{id})",
      "DELETE": "{agentName} deleted a macro (#{id})"
    },
    "INBOX_MEMBER": {
      "ADD": "{agentName} added {user} to the inbox(#{inbox_id})",
      "REMOVE": "{agentName} removed {user} from the inbox(#{inbox_id})"
    },
    "TEAM_MEMBER": {
      "ADD": "{agentName} added {user} to the team(#{team_id})",
      "REMOVE": "{agentName} removed {user} from the team(#{team_id})"
    },
    "ACCOUNT": {
      "EDIT": "{agentName} updated the account configuration (#{id})"
    },
    "CONVERSATION": {
      "ADD": "{agentName} criou uma conversa (#{id})",
      "EDIT": "{agentName} atualizou uma conversa (#{id}): {changes}"
    },
    "CONTACT": {
      "ADD": "{agentName} criou um contacto (#{id})",
      "EDIT": "{agentName} atualizou um contacto (#{id}): {attributes}"
    }
  }
}
